import { Swiper } from 'swiper';
import { EffectCreative,EffectCards,Autoplay,A11y,EffectCube, 
	Keyboard, Navigation, Pagination,FreeMode, Mousewheel,EffectFlip, 
	EffectCoverflow,EffectFade ,Scrollbar} from 'swiper/modules';

export function SwiperInit( container, options = {}, isfront=false ) {

    const modules = [Autoplay, Keyboard, Navigation, Pagination, FreeMode, Mousewheel,A11y];

    const effectModules = {
		slide:'' ,
		flip: EffectFlip,
		fade: EffectFade,
		coverflow: EffectCoverflow,
		cube: EffectCube,
		cards: EffectCards,
		creative: EffectCreative,
	};
	
	if (options.effect && effectModules[options.effect]) {
		modules.push(effectModules[options.effect]);
	}
	
	if (options.scrollbar) {
		modules.push(Scrollbar);
	}
	
	// Parse the `data-swiper` JSON from the container
	const swiperData = container.getAttribute('data-swiper');
	let parsedData = {};
	if (swiperData) {
		try {
			parsedData = JSON.parse(swiperData);
		} catch (error) {
			console.error("Error parsing data-swiper attribute:", error);
		}
	}

	// Use the parsed data as fallback values
	const slidesPerView = parsedData.slidesPerView ?? options?.slidesPerView ?? 1;
	const spaceBetween = parsedData.spaceBetween ?? options?.spaceBetween ?? 10;
	const initialSlide = parsedData.initialSlide ?? options?.initialSlide ?? 10;

	// Set parameters based on the device view (Desktop, Tablet, Mobile)
	const isDesktop = options.viewslider === 'Desktop';
	const isTablet = options.viewslider === 'Tablet';
	const isMobile = options.viewslider === 'Mobile';

	let getSwiperParametrs=(options) => {

		const commonParams = {
			createElements: true,
			centeredSlides: options?.centerSlides ?? false,
			grabCursor: options?.grabCursor ?? true,
			keyboard: true,
			modules: modules,
			navigation: options?.navigation ?? false,
			pagination: options?.pagination ?? false,
			simulateTouch: options?.simulateTouch ?? true,
			freeMode: true,
			scrollbar: options?.scrollbar ?? true,
		};

		if (isfront) {
			return {
				...commonParams,
				autoplay: options?.autoplay ?? false,
				initialSlide: initialSlide-1,
				mousewheel: options?.mousewheel ?? true,
				...(options.effect && options.effect !== "none" && { effect: options.effect ?? "fade" }),
				...(["fade", "flip", "cube", "cards"].includes(options.effect) ? {} : {
					slidesPerView: slidesPerView,
					spaceBetween: spaceBetween,
					loop: options?.loop,
				}),
				...(options.effect === "cards" && { loop: false }),
			};
		}else {
			return {
				...commonParams,
				initialSlide: isDesktop 
					? (options?.initialSlide ?? 1) - 1 
					: isTablet 
					? (options?.initialSlideTablet ?? 1) - 1 
					: isMobile 
					? (options?.initialSlideMobile ?? 1) - 1 
					: 0,
				pagination: {
					enabled: true,
					clickable: true,
					...(options.dotstype === "numbers" && { type: "fraction" }),
					...(options.dotstype === "bullets" && {
						dynamicBullets: true,
						dynamicMainBullets: options?.dynamicMainBullets ?? 1,
					}),
					...(options.dotstype === "progressbar" && { type: "progressbar" }),
				},
				...(["fade", "cards"].includes(options.effect) ? {} : { loop: true }),
				...(["fade", "flip", "cube", "cards"].includes(options.effect) ? {} : {
					slidesPerView: isDesktop ? options?.slidesPerView : isTablet ? options?.slidesPerViewTablet : isMobile ? options?.slidesPerViewMobile : 1,
					spaceBetween: isDesktop ? options?.spaceBetween : isTablet ? options?.spaceBetweenTablet : isMobile ? options?.spaceBetweenMobile : 10,
				}),
				...(options.effect && options.effect !== "none" && { effect: options.effect ?? "fade" }),
				...(options.effect === "cards" && { loop: false }),
				mousewheel: {
					enabled: options?.mousewheel ?? true,
					sensitivity: 7,
				},
			};
		}

	};

	return new Swiper( container, getSwiperParametrs(options) );

}